<svg class="icon" [ngClass]="class" [attr.title]="title">
  <use [attr.xlink:href]="'#' + name" />
</svg>